import parityColorStyles from 'lumen/components/parity/parity-colors.module.css';
import type { PeriodParity } from 'lumen/models/period';
import { POSITION_TO_BASERATE } from 'lumen/utils/constants/general-constants';

export default function parityClass(periodParity?: PeriodParity): string {
  switch (periodParity?.position_to_baserate) {
    case POSITION_TO_BASERATE.LOSS_SOLDOUT:
    case POSITION_TO_BASERATE.LOSS_PRICE_DIFFERENCE:
      return parityColorStyles.loss;
    case POSITION_TO_BASERATE.WIN_PRICE_DIFFERENCE:
    case POSITION_TO_BASERATE.WIN_SOLDOUT:
      return parityColorStyles.win;
    case POSITION_TO_BASERATE.MEET:
      return parityColorStyles.meet;
    case POSITION_TO_BASERATE.NO_DATA:
    default:
      return '';
  }
}
